import React from "react";
import { Form } from "react-bootstrap";
import { useLocalStorage } from "../../../hooks/useLocalStorage";
import { storageKeys } from "../../../constants/storageKeys";
import initialSettings from "../../../constants/settings.json";

const LLMSettings = () => {
  const [selectedModel, setSelectedModel] = useLocalStorage(
    storageKeys.LLM_MODEL,
    JSON.parse(initialSettings.localStorage.LLM_MODEL)
  );
  const [temperature, setTemperature] = useLocalStorage(
    storageKeys.LLM_RESPONSE_TEMPERATURE,
    JSON.parse(initialSettings.localStorage.LLM_RESPONSE_TEMPERATURE)
  );
  const [useToolsCalls, setUseToolsCalls] = useLocalStorage(
    storageKeys.USE_TOOLS_CALLS,
    JSON.parse(initialSettings.localStorage.USE_TOOLS_CALLS)
  );

  const [additionalLLMOptions, setAdditionalLLMOptions] = useLocalStorage(
    storageKeys.ADDITIONAL_LLM_OPTIONS,
    null
  );


  return (
    <>
      <Form.Group className="mb-4">
        <Form.Label>LLM Model</Form.Label>
        <Form.Control
          value={selectedModel}
          onChange={(e) => setSelectedModel(e.target.value)}
        />
      </Form.Group>

      <Form.Group className="mb-4">
        <Form.Label>Temperature</Form.Label>
        <Form.Control
          type="number"
          min="0"
          max="1"
          step="0.1"
          value={temperature === null ? "" : temperature}
          placeholder="(optional)"
          onChange={(e) => {
            const value = e.target.value;
            if (value === "") {
              setTemperature(null);
            } else {
              const num = parseFloat(value);
              if (!isNaN(num) && num >= 0 && num <= 1) {
                setTemperature(num);
              }
            }
          }}
        />
        <div className="form-text">
          Leave blank to not use temperature.
        </div>
      </Form.Group>

      <Form.Group className="mb-4">
        <Form.Label>
          Additional LLM Options{" "}
          <span
            className="badge bg-info text-dark ms-2"
            style={{ fontSize: "0.8em" }}
          >
            Advanced
          </span>
        </Form.Label>
        <Form.Control
          as="textarea"
          rows={4}
          value={
            typeof additionalLLMOptions === "string"
              ? additionalLLMOptions
              : additionalLLMOptions
              ? JSON.stringify(additionalLLMOptions, null, 2)
              : ""
          }
          placeholder='e.g. { "presence_penalty": 0.5, "frequency_penalty": 0.2 }'
          onChange={(e) => {
            const value = e.target.value;
            // Always store the raw string so user can type freely
            setAdditionalLLMOptions(value);
            // Only parse and store as object if valid JSON
            try {
              if (value.trim() === "") {
                setAdditionalLLMOptions(null);
              } else {
                const parsed = JSON.parse(value);
                setAdditionalLLMOptions(parsed);
              }
            } catch (err) {
              // Do nothing, let user keep typing
            }
          }}
        />
        <div className="form-text">
          Enter any additional options to send to the LLM API as a JSON object.<br />
        </div>
      </Form.Group>

      <Form.Group className="mb-4">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <Form.Label>
              Send Schema as Message{" "}
              <span
                className="badge bg-warning text-dark ms-2"
                style={{ fontSize: "0.8em" }}
              >
                Experimental
              </span>
            </Form.Label>
            <div className="form-text">
              By default, the app uses tool calls to send the schema to the LLM.
              Enable this option to use messages instead (experimental). If the
              LLM endpoint does not support recursive schemas in tool calls, use this option to send the
              schema in a message.
            </div>
          </div>
          <Form.Check
            type="switch"
            id="use-tools-calls-toggle"
            checked={!useToolsCalls}
            onChange={(e) => setUseToolsCalls(!e.target.checked)}
            style={{ marginLeft: "1rem" }}
          />
        </div>
      </Form.Group>
    </>
  );
};

export default LLMSettings;
